<script setup>
import { useI18n } from "vue-i18n";

const { t } = useI18n();
</script>

<template>
  <div class="bg-primary">
    <div class="section-container">
      <div class="container mx-auto px-0">
        <div class="grid md:grid-cols-2 items-stretch">
          <!-- Left Side: Background Image -->
          <div class="w-full h-full">
            <img
              src="@/../img/home/road.jpg"
              alt="Futuristische stad"
              class="w-full h-full object-cover rounded-lg shadow-lg"
            />
          </div>

          <!-- Right Side: Content -->
          <div class="bg-white p-12 flex flex-col justify-center">
            <h2 class="text-4xl mb-8 pb-2">{{ t("Blijf Ontwikkelen") }}</h2>

            <div class="space-y-8">
              <!-- Step 1 -->
              <div class="relative border-2 p-5 rounded-lg shadow-md">
                <div
                  class="absolute -left-6 top-1/2 transform -translate-y-1/2 w-10 h-10 flex items-center justify-center bg-[#437066] text-white text-lg font-bold rounded-md shadow-md border-2 border-white"
                >1</div>
                <h3 class="text-xl font-semibold">{{ t("Volg onze updates") }}</h3>
                <p>{{ t("Blijf op de hoogte van de nieuwste cursussen, evenementen en ontwikkelingen in de zorg. Schrijf je in voor onze nieuwsbrief en volg ons op sociale media.") }}</p>
              </div>

              <!-- Step 2 -->
              <div class="relative border-2 p-5 rounded-lg shadow-md">
                <div
                  class="absolute -left-6 top-1/2 transform -translate-y-1/2 w-10 h-10 flex items-center justify-center bg-[#437066] text-white text-lg semi rounded-md shadow-md border-2 border-white"
                >2</div>
                <h3 class="text-xl font-semibold">{{ t("Neem contact op") }}</h3>
                <p>{{ t("Heb je vragen of wil je meer informatie? Neem gerust contact met ons op. We helpen je graag verder.") }}</p>
              </div>

              <!-- Step 3 -->

              <div class="relative border-2 p-5 rounded-lg shadow-md">
                <div
                  class="absolute -left-6 top-1/2 transform -translate-y-1/2 w-10 h-10 flex items-center justify-center bg-[#437066] text-white text-lg font-bold rounded-md shadow-md border-2 border-white"
                >3</div>
                <h3 class="text-xl font-semibold">{{ t("Begin vandaag nog") }}</h3>
                <p>{{ t("Wacht niet langer en begin met jouw leertraject bij Zorgblik Academie. Investeer in jouw professionele groei en bouw aan de toekomst van de zorg.") }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>